import Vue from "vue";
import store from "@/store/store";
import i18n from "../../i18n";

const state = {
  imgUrl: process.env.VUE_APP_IMG_URL,
  email: "",
  name: "",
  uuid: "",
  slug: "",
  registration_choice: null,
  can_register_for_digital_card: false,
  should_register_with_card_barcode: false,
  should_register_with_license_plate: false, //deprecated
  allow_registration_with_invoice_card: false,
  allow_registration_by_anonymous_card: false,
  cashout_administration_fee: 0,
  cashout_administration_fee_limit: 0,
  has_cashout_license: false,
  template_settings: {},
  registration_form_fields: {},
  profile_form_fields: {},
  campaigns: [],
  prepaid_bonuses: [],
  organization_loyalty_settings: [],
  main_page: "home",
  vat_number_validation_patterns: {}
};

const actions = {
  login(context) {
    Vue.prototype.$http
      .get("/api/configuration/v1/login")
      .then(response => {
        context.commit("login", response.data);
        if (
          response.data.organization_loyalty_settings &&
          response.data.organization_loyalty_settings
            .allow_loyalty_subscriptions
        ) {
          context.state.main_page = "subscriptions";
        }
      })
      // eslint-disable-next-line no-unused-vars
      .catch(() => {
        store.commit("viewstate/notify", {
          text: i18n.t("error.something_went_wrong"),
          color: "error"
        });
      });
  },
  home() {
    return Vue.prototype.$http.get("/api/configuration/v1/home");
  }
};

const mutations = {
  login(state, payload) {
    // is there a nicer way for this?
    if (payload === undefined) {
      return;
    }
    Object.assign(state.template_settings, payload.template_settings);
    payload.form_fields.forEach(item => {
      state.registration_form_fields[item.field] = item.display;
    });
    delete payload.template_settings;
    delete payload.form_fields;
    Object.keys(payload).forEach(key => {
      state[key] = payload[key];
    });
    let link =
      document.querySelector("link[rel='icon']") ||
      document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "icon";
    link.href = process.env.VUE_APP_IMG_URL + state.template_settings.favicon;
    document.getElementsByTagName("head")[0].appendChild(link);

    let appleLink =
      document.querySelector("link[rel='apple-touch-icon']") ||
      document.createElement("link");
    appleLink.rel = "apple-touch-icon";
    appleLink.href =
      process.env.VUE_APP_IMG_URL + state.template_settings.favicon;
    document.getElementsByTagName("head")[0].appendChild(appleLink);
  },
  home(state, payload) {
    Object.assign(state.template_settings, payload.template_settings);
    payload.form_fields.forEach(item => {
      state.profile_form_fields[item.field] = item.display;
    });
    delete payload.template_settings;
    delete payload.form_fields;
    Object.keys(payload).forEach(key => {
      state[key] = payload[key];
    });
  },
  chooseDigitalRegistration(state) {
    state.registration_choice = "digital";
  },
  choosePhysicalRegistration(state) {
    state.registration_choice = "physical";
  },
  resetRegistrationChoice(state) {
    state.registration_choice = null;
  }
};

const getters = {
  hasCampaigns: state => {
    return state.campaigns.length > 0;
  },
  hasRegistrationChoice: state => {
    return (
      state.can_register_for_digital_card &&
      state.should_register_with_card_barcode
    );
  },
  hasChosenDigitalRegistration: state => {
    return state.registration_choice === "digital";
  },
  hasChosenPhysicalRegistration: state => {
    return state.registration_choice === "physical";
  },
  shouldFillQRCodeField: (state, getters) => {
    let has_registration_choice = getters.hasRegistrationChoice;
    return (
      !has_registration_choice ||
      (has_registration_choice && getters.hasChosenPhysicalRegistration)
    );
  },
  getOrganizationLogo: state => {
    return state.imgUrl + state.template_settings.organization_logo;
  },
  hasDynamicTopupAmount: state => {
    if (!state.organization_loyalty_settings) {
      return false;
    }
    return (
      state.organization_loyalty_settings.allow_dynamic_topup_amount === true
    );
  },
  getMaximumDynamicAmount: state => {
    let settings = state.organization_loyalty_settings;
    return settings ? settings.maximum_dynamic_topup_amount : null;
  },
  getMinimumDynamicAmount: state => {
    let settings = state.organization_loyalty_settings;
    return settings ? settings.minimum_dynamic_topup_amount : null;
  },
  getAvailableSubscriptions: state => {
    return state.organization_loyalty_settings
      .available_subscriptions_for_customers;
  },
  isSubscriptionsAllowed: state => {
    return (
      state.organization_loyalty_settings.allow_loyalty_subscriptions === true
    );
  },
  showTransactionsMenuTab: state => {
    if (!state.organization_loyalty_settings) {
      return false;
    }
    return state.organization_loyalty_settings.hide_transactions === false;
  },
  showPrepaidAmount: state => {
    const settings = state.organization_loyalty_settings;

    if (!settings || Array.isArray(settings)) {
      return true;
    }

    return settings.hide_prepaid_amount === false;
  }
};

export const config = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
